import React from "react";
import styled from "styled-components";
import { X, Info, ArrowLeft } from "phosphor-react";

// Context
import { ACTIONS, useModalHistory } from "../../context/ModalHistoryProvider";

// Components
import QueueStyle from "../Styled/Queue.style";

// Utils
import shadows from "../../utils/constants/SHADOWS";
import typography from "../../utils/constants/TYPOGRAPHY";
import colors from "../../utils/constants/COLORS";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router";

const Modal = ({
  children,
  title,
  helpMessage,
  icon = <Info size={20} color={colors.informational.color} />,
  size = { width: "22rem", height: "auto" },
}) => {
  const [{modalHistory}, dispatchModalHistory] = useModalHistory();
  const navigate = useNavigate();

  const popEnd = () => {
    dispatchModalHistory({ type: ACTIONS.POP_END }); 
    if(modalHistory?.length === 0) {
      navigate("/")
    }
  };
  const popAll = () => {
    dispatchModalHistory({ type: ACTIONS.POP_ALL });
    if(modalHistory?.length === 0) {
      navigate("/")
    }
  };

  return (
    <Container>
      <Background onClick={popAll}></Background>
      <Card size={size}>
        <Inner>
          <Header>
            <QueueStyle>
              <IconButton onClick={popEnd}>
                <Tooltip title="Go back">
                  <Icon style={{ cursor: "pointer" }}>
                    <ArrowLeft size={20} />
                  </Icon>
                </Tooltip>
              </IconButton>
              <QueueStyle justifyContent="center" gap="10px">
                {title}
                <Icon title={helpMessage} style={{ cursor: "help" }}>
                  {icon}
                </Icon>
              </QueueStyle>
              <IconButton onClick={popAll}>
                <Tooltip title="Close">
                  <Icon style={{ cursor: "pointer" }}>
                    <X size={20} />
                  </Icon>
                </Tooltip>
              </IconButton>
            </QueueStyle>
          </Header>
          {children}
        </Inner>
      </Card>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;

  position: absolute;
  top: 0;
  z-index: 100;
`;

const Background = styled.div`
  background-color: rgba(0, 0, 0, 0.77);
  backdrop-filter: blur(2px);
  height: 100%;
  width: 100%;

  position: absolute;
  top: 0;
  left: 0;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: ${shadows.depth5};
  color: "var(--carter-info)";
  width: ${(props) => props.size.width};
  height: ${(props) => props.size.height};

  position: relative;
`;

const Inner = styled.div`
  padding: 0 1rem 1rem 1rem;
  height: 100%;
  width: 100%;
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 1.25rem;
  width: 1.25rem;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  column-gap: 12px;
  margin-bottom: 1rem;
  width: 100%;

  font-size: ${typography.heading.size};
  font-weight: ${typography.heading.weight};
  line-height: ${typography.heading.lineHeight};

  position: sticky;
  left: 0;
  top: 0;
  background-color: #fff;
  z-index: 10;
  border-bottom: 2px dashed ${colors.informational.color};
`;

const ModalHistoryBreadCrumb = styled.span`
  font-size: xx-small;
  color: #717171;
`;

export default Modal;
